export default __webpack_public_path__ + "static/Lora-Medium-ea6d21687c88ed52a7a581b63a57429a.ttf";